import { render, staticRenderFns } from "./IndexTag.vue?vue&type=template&id=3709c4c0&scoped=true&"
import script from "./IndexTag.vue?vue&type=script&lang=js&"
export * from "./IndexTag.vue?vue&type=script&lang=js&"
import style0 from "./IndexTag.vue?vue&type=style&index=0&id=3709c4c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3709c4c0",
  null
  
)

export default component.exports